import { Button, ButtonWithIcon, stringTemplate, Text } from '@oy/ui';
import { Colors } from '@oy/uicore';
import classNames from 'classnames';
import React from 'react';
import { useUITranslate } from '../../../../../hooks/useUITranslate';
import { EmptyStateInfo } from '../../type';
import styles from './InfoAction.module.css';

export const InfoAction = ({
  buttons,
  detail,
  title,
  productTranslation,
}: EmptyStateInfo) => {
  const { translate } = useUITranslate();

  const defaultProductTitle = stringTemplate({
    str: translate('You Have No Transaction in This Product'),
    template: {
      product: productTranslation ?? '',
    },
  });

  const mainTitle = productTranslation
    ? defaultProductTitle
    : title || translate('No Transaction Found');

  return (
    <div className={styles.container}>
      <Text
        textStyle={Text.Style.HeadingMd}
        className={classNames(styles.text, styles.title)}
      >
        {mainTitle}
      </Text>
      <Text
        textStyle={Text.Style.BodyLgRegular}
        color={Colors.BLACK40}
        className={styles.text}
      >
        {detail || translate('Adjust the filter or create new transactions')}
      </Text>

      {buttons && (
        <div className={styles.buttons}>
          {buttons.mainButton && (
            <ButtonWithIcon
              buttonType={Button.Type.Filled}
              color={Button.Color.Primary}
              {...buttons.mainButton}
            />
          )}
          {buttons.supportButton && (
            <Button
              buttonType={Button.Type.Outlined}
              size={Button.Size.Small}
              color={Button.Color.Secondary}
              style={{ width: 'fit-content' }}
              {...buttons.supportButton}
            />
          )}
        </div>
      )}
    </div>
  );
};
